import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpErrorViewerInterceptor } from 'app/core/http-error-viewer/http-error-viewer.interceptor';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    imports  : [
        HttpClientModule,
        MatSnackBarModule
    ],
    providers: [
        {
            provide : HTTP_INTERCEPTORS,
            useClass: HttpErrorViewerInterceptor,
            multi   : true
        }
    ]
})
export class HttpErrorViewerModule
{
}
